import * as React from 'react';
import { useWindowEvent } from './useWindowEvent';

export function useWindowSize() {
    const [windowDimensions, setWindowDimensions] = React.useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const windowSizeChangeHandler = () =>
        setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });

    useWindowEvent('resize', windowSizeChangeHandler, []);
    useWindowEvent('orientationchange', windowSizeChangeHandler, []);

    return windowDimensions;
}
